import React from "react";

const NewsCard = ({ post }) => {
  // Function to get user initials for profile picture fallback

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : "U";
  };

  // Function to get post type specific styling
  const getPostTypeColor = (type) => {
    switch (type) {
      case "policy":
        return "#6366f1";
      case "news":
        return "#10b981";
      case "announcement":
        return "#3b82f6";
      default:
        return "#6b7280";
    }
  };

  // Extract first <p> content from HTML
  const extractFirstParagraph = (html) => {
    const match = html?.match(/<p[^>]*>(.*?)<\/p>/i);
    if (!match) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = match[1];
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    marginBottom: "24px",
    maxWidth: "400px",
    border: "none",
  };

  const imageStyle = {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  };

  const contentStyle = {
    padding: "20px",
  };

  const badgeStyle = {
    display: "inline-block",
    backgroundColor: getPostTypeColor(post.type),
    color: "white",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "capitalize",
    marginBottom: "12px",
  };

  const titleStyle = {
    fontSize: "18px",
    fontWeight: "600",
    color: "#1f2937",
    marginBottom: "8px",
    lineHeight: "1.4",
  };

  const descriptionStyle = {
    fontSize: "14px",
    color: "#6b7280",
    lineHeight: "1.5",
    marginBottom: "16px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    minHeight: "5em", // consistent height (2 lines)
  };

  const statsStyle = {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
  };

  const statItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "14px",
    color: "#6b7280",
  };

  const authorSectionStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    paddingTop: "16px",
    borderTop: "1px solid #f3f4f6",
  };

  const avatarStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
  };

  const avatarFallbackStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    color: "#6b7280",
  };

  const authorInfoStyle = {
    flex: 1,
  };

  const authorNameStyle = {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1f2937",
    marginBottom: "2px",
  };

  const authorRoleStyle = {
    fontSize: "12px",
    color: "#6b7280",
  };

  const metaInfoStyle = {
    textAlign: "right",
    fontSize: "12px",
    color: "#6b7280",
  };

  return (
    <div style={cardStyle}>
      {/* Image or Custom Policy Card */}
      {post.type === "policy" ? (
        <div className="d-flex justify-content-center align-items-center bg-light ">
          <div
            className="card border-0 shadow-sm p-5 text-center"
            style={{
              backgroundColor: "#E8E2D5",
              height: "200px",
              width: "100%",
            }}
          >
            {/* EB Logo */}
            <div className="mb-3">
              <h1
                className="display-4 mb-0"
                style={{
                  fontFamily: "serif",
                  fontWeight: "300",
                  color: "#333",
                  letterSpacing: "2px",
                }}
              >
                EB
              </h1>
            </div>

            <p
              className="text-muted mb-2"
              style={{
                fontSize: "14px",
                fontWeight: "400",
                letterSpacing: "1px",
              }}
            >
              Empowering Beauty
            </p>

            <h2
              className="h4 mb-2"
              style={{
                fontWeight: "bold",
                color: "#333",
                fontSize: "20px",
              }}
            >
              Policy Update
            </h2>
          </div>
        </div>
      ) : (
        post.image && (
          <img
            src={`${process.env.REACT_APP_BUCKET_URL}${post.image}`}
            alt={post.title || "Post image"}
            style={imageStyle}
          />
        )
      )}

      {/* Content Section */}
      <div style={contentStyle}>
        {/* Post Type Badge */}
        <span style={badgeStyle}>{post.type}</span>

        {/* Stats Section */}
        <div style={statsStyle}></div>

        {/* Title */}
        <h3 style={titleStyle}>
          {post.title === ""
            ? post.type === "announcement"
              ? "Announcement"
              : post.type === "news"
              ? "News"
              : ""
            : post.title}
        </h3>

        {/* Description */}
        {post.description &&
          (post.type === "policy" ? (
            <div style={descriptionStyle}>
              {extractFirstParagraph(post.description)}
            </div>
          ) : (
            <div style={descriptionStyle}>{post.description}</div>
            // <p style={descriptionStyle}>{post.description}</p>
          ))}

        {/* Author Section */}
        <div style={authorSectionStyle}>
          <div>
            {post.addedBy.profileImageUrl ? (
              <img
                // src={post.addedBy.userProfileImage}
                src={`${process.env.REACT_APP_BUCKET_URL}${post.addedBy.profileImageUrl}`}
                alt={post.addedBy.fullName || "User"}
                style={avatarStyle}
              />
            ) : (
              <div style={avatarFallbackStyle}>
                {getInitials(post.addedBy.fullName || "A")}
              </div>
            )}
          </div>

          <div style={authorInfoStyle}>
            <div style={authorNameStyle}>
              {post.addedBy.fullName || "Anonymous"}
            </div>
            <div style={authorRoleStyle}>{post.addedBy.role || "Author"}</div>
          </div>

          {/* <div style={metaInfoStyle}>
                        <div>17 Lessons</div>
                        <div>50 Hours</div>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
